import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import SelectComponent from '../../_Components/ReactSelectComponent';
import { Controller } from 'react-hook-form';
import { buildOptionLabel } from './utils';
import SourcePicker from './SourcePicker';
import Divider from '../../_Components/Divider';
import Field from '../../_Components/Field';
import { isMobile } from "react-device-detect";

// یه شناسه‌ی یکتا برای گزینه‌ی سیستمی
const SYSTEM_ASSIGN_ID = 'SYSTEM_ASSIGN';

const SYSTEM_OPTION = {
  value: SYSTEM_ASSIGN_ID,
  title: 'تخصیص بلیط منبع توسط سیستم',
  subtitle: 'سیستم به‌صورت خودکار تخصیص می‌دهد',
  id: 'AUTO',
  isSystem: true,
};

// ------------------------------------------------------------
// یک ردیف
// ------------------------------------------------------------
const TicketRow = ({ row, index, control, ticketSources, ticket }) => {
  const sourceOptions = [
    SYSTEM_OPTION,
    ...ticketSources.map((item) => ({
      value: item.id,
      title: `${item.barcode}${item.qrCode ? " | " + item.qrCode : ''}`,
      id: item.ticketNumber,
      isSystem: false,
    })),
  ];
  // رنگ وضعیت بر اساس متن
  const getStatusStyle = (status) => {
    const s = String(status ?? '').trim();
    if (!s) return { bg: '#f1f5f9', color: '#64748b' };
    if (s.includes('تخصیص') || s.includes('فعال'))
      return { bg: '#ecfdf5', color: '#047857' };
    if (s.includes('لغو') || s.includes('غیرفعال'))
      return { bg: '#fef2f2', color: '#b91c1c' };
    if (s.includes('انتظار') || s.includes('در انتظار'))
      return { bg: '#fffbeb', color: '#b45309' };
    return { bg: '#f1f5f9', color: '#475569' };
  };

  const statusStyle = getStatusStyle(row.strStatus);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        flexDirection: isMobile ? "column" : "row",
        gap: 2,
        px: 2,
        py: 1.2,
        borderRadius: 1.5,
        border: '1px solid #e2e8f0',
        background: '#fff',
        transition: 'border-color .15s, box-shadow .15s',
        '&:hover': {
          borderColor: '#cbd5e1',
          boxShadow: '0 2px 8px -4px rgba(15,23,42,0.08)',
        },
        mb: 1
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          gap: 2,
          flex: 2,
        }}
      >
        {/* شماره ردیف */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            width: 36,
          }}
        >
          <Box
            sx={{
              background: '#f1f5f9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 11,
              fontWeight: 700,
              color: '#64748b',
              fontVariantNumeric: 'tabular-nums',
              p: 0.5,
              borderRadius: 1.5
            }}
          >
            {ticket.id}
          </Box>
        </Box>

        <Divider />

        {/* اطلاعات سرویس و عنوان */}
        <Box
          sx={{
            display: 'flex',
            gap: 5,
            flex: 2,
            minWidth: 0,
            alignItems: 'center',
          }}
        >
          <Field label="تفریح" value={row.amusementServiceName} />
          <Field label="آیتم" value={row.reserveItemTitle} />
        </Box>
      </Box>

      <Divider isHorizontal={isMobile} />

      <Box
        sx={{
          display: "flex",
          flex: 3,
        }}
      >
        {/* کدها */}
        <Box
          sx={{
            display: 'flex',
            gap: (isMobile || (row.ticketNumber.length + row.qrCode.length + row.barcode.length) > 38) ? 2 : 8,
            minWidth: 0,
            flex: 3,
            flexDirection: (isMobile || (row.ticketNumber.length + row.qrCode.length + row.barcode.length) > 38) ? "column" : "row",
          }}
        >
          <Field label="شماره بلیط منبع" value={row.ticketNumber} mono />
          <Field label="کیوآر کد" value={row.qrCode} mono />
          <Field label="بارکد" value={row.barcode} mono />
        </Box>

        <Divider />

        {/* وضعیت */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
            flexShrink: 0,
            minWidth: 90,
          }}
        >
          <Box
            sx={{
              px: 1.2,
              py: 0.4,
              borderRadius: 1,
              background: statusStyle.bg,
              color: statusStyle.color,
              fontSize: 11,
              fontWeight: 600,
              whiteSpace: 'nowrap',
            }}
          >
            {row.strStatus || '—'}
          </Box>
        </Box>
      </Box>

      <Divider isHorizontal={isMobile} />

      {/* Select منبع */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          minWidth: isMobile ? "100%" : 380,
          maxWidth: 380,
        }}
      >
        <Box sx={{ width: '100%' }}>
          <Controller
            name={`tickets[${index}].amusementServiceReserveItemTicketSourceId`}
            control={control}
            defaultValue={SYSTEM_ASSIGN_ID}
            render={({ field }) => (
              <SourcePicker
                value={field.value}
                onChange={field.onChange}
                placeholder="انتخاب منبع"
                options={sourceOptions}
              />
            )}
          />
        </Box>
      </Box>
    </Box >
  );
};

export default TicketRow;